export interface CardDisplayItem {
  brand?: string;
  last4?: string;
  gateway?: string;
  [key: string]: any;
}

/**
 * Helper to format card brand, masked last4 digits, or fall back to gateway/default label.
 * @param {CardDisplayItem | null | undefined} cardItem - The card object containing brand, last4, and gateway.
 * @param {string} [fallbackLabel] - Fallback label when brand and gateway are unavailable.
 * @returns {string} Formatted card display string.
 */
export const formatCardDisplay = (
  cardItem?: CardDisplayItem | null,
  fallbackLabel: string = 'Card',
): string => {
  if (!cardItem) return '';
  const brand = cardItem.brand?.trim() || '';
  const masked = cardItem.last4 ? `****${cardItem.last4}` : '';
  const title = [brand, masked].filter(Boolean).join(' ');
  return title || cardItem.gateway || fallbackLabel;
};

/**
 * Alias for formatCardDisplay to support PascalCase imports.
 */
export const FormatCardDisplay = formatCardDisplay;

export default formatCardDisplay;
